import React from "react";
import { useTranslation } from "react-i18next";

interface CheckoutErrorBannerProps {
  message: string | null;
  onDismiss?: () => void; // Optional callback for a dismiss button
}

const CheckoutErrorBanner: React.FC<CheckoutErrorBannerProps> = ({
  message,
  onDismiss,
}) => {
  const { t } = useTranslation();

  // Don't render anything if there's no message
  if (!message) {
    return null;
  }

  return (
    <div className="checkout-error-banner" role="alert">
      {/* Icon for visual cue */}
      <span className="error-icon" aria-hidden="true">
        !
      </span>
      {/* The error message */}
      <p className="error-message">{message}</p>
      {/* Optional dismiss button */}
      {onDismiss && (
        <button
          type="button" // Ensure it doesn't submit forms
          className="dismiss-button"
          onClick={onDismiss}
          aria-label={t("common.close", "Close")} // Accessibility label
        >
          × {/* Simple 'x' character */}
        </button>
      )}
    </div>
  );
};

export default CheckoutErrorBanner;
